
export const blogPosts = [
  {
    id: '1',
    slug: 'fetih-partisi-ve-turkiyenin-gelecegi',
    title: 'Fetih Partisi ve Türkiye\'nin Geleceğine Dair Vizyonumuz',
    category: 'Siyaset',
    date: '2025-01-20',
    readTime: '8 dakika',
    excerpt: 'Fetih Partisi olarak Türkiye\'nin her alanda güçlenmesi, milletin refahının artması ve ülkemizin uluslararası arenada hak ettiği yeri alması için kararlı adımlar atıyoruz.',
    coverImage: 'https://public.readdy.ai/ai/img_res/00d14308a0619d4759f39d2e90caeb39.jpg',
    content: `Fetih Partisi olarak Türkiye'nin her alanda güçlenmesi için kararlı adımlar atıyoruz.

## Vizyonumuz

Türkiye'nin ekonomik, sosyal ve siyasi alanda güçlenmesi için kapsamlı bir vizyon geliştirdik. Bu vizyon, milletin refahını merkeze alan, üretimi ve istihdamı ön plana çıkaran bir anlayışa dayanmaktadır.

### Temel İlkelerimiz

Fetih Partisi olarak şu temel ilkeler etrafında hareket ediyoruz:

1. **Milli Ekonomi**: Yerli üretimi desteklemek, dışa bağımlılığı azaltmak
2. **Sosyal Adalet**: Her vatandaşın eşit fırsatlara sahip olması
3. **Güçlü Devlet**: Kurumların etkin ve şeffaf işleyişi
4. **Uluslararası Prestij**: Türkiye'nin dünya sahnesindeki ağırlığını artırmak

> "Türkiye'nin gücü, milletinin birliğinden ve kararlılığından kaynaklanır."

### Geleceğe Bakış

Türkiye'yi layık olduğu yere taşımak için her alanda çalışmaya devam ediyoruz.`
  },
  {
    id: '2',
    slug: 'ulak-ve-iletisim-teknolojileri',
    title: 'ULAK ile Türkiye\'nin Yerli İletişim Teknolojilerindeki Atılımı',
    category: 'Teknoloji',
    date: '2025-01-14',
    readTime: '7 dakika',
    excerpt: 'ULAK Genel Başkanı olarak yerli ve milli iletişim teknolojilerinin geliştirilmesi, Türkiye\'nin teknolojik bağımsızlığının pekiştirilmesi için yürütülen çalışmaları paylaşıyorum.',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20telecommunications%20technology%20center%20in%20Turkey%2C%20advanced%20communication%20infrastructure%2C%20high-tech%20server%20room%20with%20Turkish%20engineers%2C%20national%20technology%20development%20concept%2C%20professional%20corporate%20environment%2C%20innovation%20atmosphere%2C%20clean%20modern%20facility&width=800&height=450&seq=blog2&orientation=landscape',
    content: `ULAK olarak Türkiye'nin iletişim teknolojilerinde yerli ve milli çözümler üretiyoruz.`
  },
  {
    id: '3',
    slug: 'is-dunyasinda-milli-kalkinma',
    title: 'İş Dünyasında Milli Kalkınma: Girişimciliğin Önemi',
    category: 'İş Dünyası',
    date: '2025-01-08',
    readTime: '6 dakika',
    excerpt: 'Türk iş insanlarının önündeki fırsatlar ve engeller üzerine değerlendirmeler. Milli kalkınmada özel sektörün üstlenmesi gereken kritik rol.',
    coverImage: 'https://readdy.ai/api/search-image?query=successful%20Turkish%20businessman%20in%20modern%20Istanbul%20office%20with%20Bosphorus%20view%2C%20confident%20executive%20portrait%2C%20contemporary%20corporate%20environment%2C%20natural%20window%20lighting%2C%20professional%20business%20attire%2C%20inspiring%20entrepreneurship%20concept&width=800&height=450&seq=blog3&orientation=landscape',
    content: `Türk iş insanları olarak milli kalkınmada kritik bir rol üstleniyoruz.`
  },
  {
    id: '4',
    slug: 'siyasette-donusum-ve-yenilesme',
    title: 'Siyasette Dönüşüm: Yeni Nesil Siyaset Anlayışı',
    category: 'Siyaset',
    date: '2024-12-30',
    readTime: '5 dakika',
    excerpt: 'Türk siyasetinde yeni bir sayfa açmak, vatandaşla daha güçlü bağlar kurmak ve şeffaf bir yönetim anlayışı inşa etmek için neler yapılmalı?',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20political%20meeting%20in%20contemporary%20Turkish%20conference%20hall%2C%20professional%20political%20discussion%2C%20formal%20meeting%20environment%2C%20national%20symbols%20in%20background%2C%20leadership%20gathering%2C%20clean%20corporate%20political%20setting%2C%20natural%20lighting&width=800&height=450&seq=blog4&orientation=landscape',
    content: `Siyasette dönüşüm, vatandaşın taleplerini merkeze almakla başlar.`
  },
  {
    id: '5',
    slug: 'turkiyenin-uluslararasi-vizyonu',
    title: 'Türkiye\'nin Uluslararası Vizyonu ve Küresel Rolü',
    category: 'Dış Politika',
    date: '2024-12-22',
    readTime: '9 dakika',
    excerpt: 'Türkiye\'nin bölgesel ve küresel güç olma yolundaki adımları, dış politika öncelikleri ve uluslararası ilişkilerdeki stratejik konumu üzerine değerlendirmeler.',
    coverImage: 'https://readdy.ai/api/search-image?query=international%20diplomatic%20meeting%20with%20Turkish%20delegation%2C%20global%20summit%20conference%20room%2C%20professional%20diplomacy%20setting%2C%20world%20map%20in%20background%2C%20formal%20international%20relations%20atmosphere%2C%20high%20quality%20event%20photography&width=800&height=450&seq=blog5&orientation=landscape',
    content: `Türkiye, coğrafi konumu ve tarihi birikimi ile küresel bir güç olma potansiyeline sahiptir.`
  },
  {
    id: '6',
    slug: 'genclik-ve-gelecek-turkiye',
    title: 'Gençlik ve Gelecek Türkiye: Yeni Nesle Yatırım',
    category: 'Toplum',
    date: '2024-12-16',
    readTime: '6 dakika',
    excerpt: 'Türkiye\'nin en büyük gücü olan gençliğe yapılan yatırımlar, eğitim politikaları ve genç girişimcilerin önünün açılması için atılması gereken adımlar.',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20Turkish%20students%20and%20entrepreneurs%20in%20modern%20university%20campus%2C%20youth%20empowerment%20concept%2C%20vibrant%20educational%20environment%2C%20future%20generation%20gathering%2C%20inspiring%20learning%20atmosphere%2C%20contemporary%20campus%20setting%2C%20natural%20lighting&width=800&height=450&seq=blog6&orientation=landscape',
    content: `Gençliğe yatırım, Türkiye'nin geleceğine yapılan en değerli yatırımdır.`
  }
];

export const blogCategories = [
  'Tümü',
  'Siyaset',
  'Teknoloji',
  'İş Dünyası',
  'Dış Politika',
  'Toplum'
];
